import { call, put, takeLatest } from "redux-saga/effects";
import { httpCreateQuestionImage } from "../../../services/questions";
import {
  editQuestionImageStart,
  editQuestionImageSuccess,
  editQuestionImageFailure,
  editQuestionStart,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";

export function* handleEditImage({ payload }) {
  const { data, callback } = payload;
  let imageFile = data?.imageUrl;
  const response = yield call(httpCreateQuestionImage, imageFile);
  const { success, raw, message } = response;

  if (success) {
    yield put(editQuestionImageSuccess());
    let modData = { ...data, imageUrl: raw?.id };
    yield put(editQuestionStart({ data: modData, callback }));
  } else {
    yield put(editQuestionImageFailure());
    networkErrorHandler(response.statusCode, message || raw?.error);
  }
}

export default function* onEditQuestionImage() {
  yield takeLatest(editQuestionImageStart.type, handleEditImage);
}
